// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1vOgO","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__14RbS"};